import { createAction, props } from '@ngrx/store';
import { SharedEntity } from '../models/shared.models';

//-- User Session Data
export const loadUserSession = createAction(
  '[SkyMiles Shared] Load User Session'
);

export const loadUserSessionSuccess = createAction(
  '[SkyMiles Shared] Load User Session Success',
  props<{ session: SharedEntity }>()
);

export const loadUserSessionFailure = createAction(
  '[SkyMiles Shared] Load User Session Failure',
  props<{ error: SharedEntity }>()
);

//-- Sitewide User Session Data
export const loadSiteWideUserSession = createAction(
  '[SkyMiles Shared] Load SiteWide User Session'
);

export const loadSiteWideUserSessionSuccess = createAction(
  '[SkyMiles Shared] Load SiteWide User Session Success',
  props<{ session: SharedEntity }>()
);

export const loadSiteWideUserSessionFailure = createAction(
  '[SkyMiles Shared] Load SiteWide User Session Failure',
  props<{ error: SharedEntity }>()
);
